import ApiService from 'services/ApiService/ApiService';
import { computeEndpoint } from 'services/GamesService/GamesService';
import {
  GET_ACTIVE_GAME_INFO_ERROR,
  GET_ACTIVE_GAME_INFO_RESPONSE,
} from 'services/MessagingService/EventNames';
import { MessagingService } from 'services/MessagingService/MessagingService';


type ActionPayload = Partial<{
  roomName: string;
  token: string;
  price: string;
  index: number;
}>;

export type Action = (data: ActionPayload) => Promise<void>;

abstract class Game {
  messagingService: MessagingService;

  protected constructor(messagingService: MessagingService) {
    this.messagingService = messagingService;
  }

  getActiveGamesInfo = async(
    roomName: string,
    token: string,
    isRetry?: boolean
  ): Promise<void> => {
    const url = computeEndpoint(roomName);
    const params = { token };

    try {
      const response = await ApiService.get(url, {
        params,
        withCredentials: false,
      });
      if (response.data) {
        this.messagingService.emit(GET_ACTIVE_GAME_INFO_RESPONSE, response.data);
      }
    } catch (error) {
      if (!isRetry) {
        this.messagingService.emit(GET_ACTIVE_GAME_INFO_ERROR, { roomName, token });
      }
    }
  };
}

export default Game;
